import { FunctionComponent, useEffect, useState } from 'react';
import { useStore } from '@hub/helpers/use-store';
import { LoadingState, useLoading } from '@monorepo/react-hooks';
import {
  Account,
  ConsistencyRuleResult,
  ConsistencyRules,
} from '@monorepo/types';
import BestTradeProfitLimitRuleCard from '../../dashboard-common-new/account-rules/best-trade-profit-limit/best-trade-profit-limit';
import MinimumTradesRuleCard from '../../dashboard-common-new/account-rules/minimum-trades/minimum-trades';
import { DashboardCardType } from '../../dashboard-common-new/cards-wrapper/inactive-days';
import ProfitableDays from '../../dashboard-common-new/cards-wrapper/profitable-days';

interface Props {
  account: Account;
}

const AccountRulesTtp: FunctionComponent<Props> = ({ account }) => {
  const { isLoading, updateLoadingState } = useLoading();
  const [currentConsistencyRulesState, setCurrentConsistencyRulesState] =
    useState<Record<ConsistencyRules, ConsistencyRuleResult>>();

  const {
    dataStore: { accountStore, programStore },
  } = useStore();

  const hasRules = programStore.hasRules(account.programId);

  useEffect(() => {
    const init = async () => {
      if (!hasRules || !account.tsAccountId) {
        return;
      }

      try {
        updateLoadingState(LoadingState.Loading);
        const accountConsistencyRules = await accountStore.getConsistencyRules(
          account.tsAccountId,
        );

        setCurrentConsistencyRulesState(accountConsistencyRules);
      } catch (error) {
        console.error(error);
      } finally {
        updateLoadingState(LoadingState.Loaded);
      }
    };
    init();
  }, []);

  if (!hasRules || !account.tsAccountId) {
    return;
  }

  return (
    <>
      {currentConsistencyRulesState?.['best-trade-profit-limit'] && (
        <BestTradeProfitLimitRuleCard
          programId={account.programId}
          isLoading={isLoading}
          currentBestTradeProfit={
            currentConsistencyRulesState?.['best-trade-profit-limit']
          }
        />
      )}
      {currentConsistencyRulesState?.['minimum-trades'] && (
        <MinimumTradesRuleCard
          programId={account.programId}
          isLoading={isLoading}
          currentTradesNumber={
            currentConsistencyRulesState?.['minimum-trades'].current
          }
        />
      )}
      {currentConsistencyRulesState?.['profitable-days'] && (
        <ProfitableDays
          accountId={account.tsAccountId}
          programId={account.programId}
          type={DashboardCardType.Rule}
        />
      )}
    </>
  );
};

export default AccountRulesTtp;
